import { Card, Col, Image, Modal, Row, Space } from 'antd';
import React, { useState } from 'react';
import { useMedia } from 'react-use';
import { WrongIcon } from '../../../../../../assets/svg';
import {
  BREAKPOINTS,
  GA_EVENT,
  GA_LABEL,
} from '../../../../../../common/constants';
import { Event } from '../../../../../../common/trackEvents';
import EllipsisText from '../../../../../../components/EllipsisText';

const AdditionalCommentsModal = ({
  showModal,
  setShowModal,
  additionalComments = [],
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [previewImageKey, setPreviewImageKey] = useState('');
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  const getPhotos = (photos, imageId) => {
    return photos?.length ? (
      <Image.PreviewGroup
        preview={{
          visible: imageId === previewImageKey && isVisible,
          onVisibleChange: (visible) => {
            setIsVisible(visible);
            if (visible) {
              Event(GA_EVENT.OPENED_IMAGE_VIEWER, {
                label: GA_LABEL.OPENED_IMAGE_VIEWER,
                // eslint-disable-next-line no-undef
                pathname: window?.location?.href,
              });
            }
          },
        }}
      >
        <Space className="image-preview-wrapper justify-start">
          {React.Children.map(photos, (photo) => (
            <Image
              src={photo}
              alt="logo"
              height={isDesktopViewport ? '64px' : '32px'}
              width={isDesktopViewport ? '64px' : '32px'}
              onClick={() => setPreviewImageKey(imageId)}
            />
          ))}
          {photos?.length - 1 > 0 && (
            <div
              className="pointer extra-count"
              onClick={() => {
                setIsVisible(true);
                setPreviewImageKey(imageId);
              }}
            >{`+ ${photos?.length - 1}`}</div>
          )}
        </Space>
      </Image.PreviewGroup>
    ) : (
      '-'
    );
  };

  return (
    <div id="additional-comments-modal">
      <Modal
        maskClosable={false}
        open={showModal}
        onCancel={() => setShowModal(false)}
        closable
        footer={null}
        closeIcon={<WrongIcon />}
        getContainer={() =>
          // eslint-disable-next-line no-undef
          document.getElementById('additional-comments-modal')
        }
      >
        <div>
          <h2>Additional Comments</h2>
          <div className="common-scroll-wrapper position-relative">
            <div className="position-absolute width-percent-100 infinite-data-container auditor-comment-modal">
              {additionalComments?.map((comment, index) => (
                <Card
                  className="comment-card mb-15"
                  key={comment?.remark || `comment-${index}`}
                >
                  <Row gutter={10} justify="space-between" align="middle">
                    <Col>
                      <div className="comment-time">Remark</div>
                      <EllipsisText
                        className="bold-detail-text"
                        text={comment?.remark}
                      />
                    </Col>
                  </Row>
                  {comment?.assets?.length > 0 && (
                    <Row gutter={10}>
                      <Col span={24}>
                        <div className="comment-time mt-16">Images</div>
                        <div className="mt-10">
                          {getPhotos(comment?.assets, `comment-${index}`)}
                        </div>
                      </Col>
                    </Row>
                  )}
                </Card>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AdditionalCommentsModal;
